<template>
  <v-ons-page @init="initPdf()">

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        <v-ons-toolbar-button v-if="zoom > 1" modifier="right" @click="zoom = zoom - 0.25">
          <v-ons-icon icon="search-minus"></v-ons-icon>
        </v-ons-toolbar-button>
        Contrat PDF - {{ cultLabel }}
      </div>
      <div class="right">
        <v-ons-toolbar-button @click="zoom = zoom + 0.25">
          <v-ons-icon icon="search-plus"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div @scroll="onScroll" class="content" id="pdf-container">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <section v-if="! isPdfLoaded" style="text-align: center; margin-top: 20px;">
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </section>

      <v-ons-list v-if="isPdfLoaded && isSignature" modifier="noborder transparent">
        <app-label input-id="signaturePad" :label="'Signez à l\'aide de votre ' + ($ons.platform.isWebView() ? 'doigt' : 'souris')"
                    :error-msg-list="errorMsgList">
        </app-label>
        <v-ons-list-item modifier="nodivider signature">
          <canvas ref="signaturePad"></canvas>
        </v-ons-list-item>
        <v-ons-list-item modifier="perfbutton">
          <v-ons-button modifier="quiet" @click="deleteSignature">
            Effacer la signature
          </v-ons-button>
        </v-ons-list-item>
      </v-ons-list>

    </div>

    <v-ons-bottom-toolbar modifier="cta background">
      <div v-if="(isSignature || isOTP) && ! isShow.signature">
        Faites défiler le contrat
        pour pouvoir le signer
      </div>
      <v-ons-button v-else-if="isOTP && isShow.signature" modifier="large--cta perflarge" @click="isShow.otp = true" :disabled="isSubmit">
        Signer le contrat
        <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </v-ons-button>
      <v-ons-button v-else-if="isSignature && isShow.signature" modifier="large--cta perflarge" @click="saveSignature">
        Signer le contrat
        <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </v-ons-button>
      <v-ons-button v-else modifier="large--cta perflarge" @click="downloadContrat" :disabled="! isPdfLoaded">
        Télécharger le contrat
      </v-ons-button>
    </v-ons-bottom-toolbar>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShow.otp">
      <template slot="title">
        Code SMS
      </template>
      Veuillez renseigner le code reçu par {{ clientContact }} pour valider la signature :
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input input-id="inputOtp" ref="inputOtp" v-model="otp.value" placeholder="Indiquez le code à 6 chiffres" @keyup-enter="closeKeyboard">
        </app-input>
      </v-ons-list>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShow.otp = false">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="saveOTP">Valider</v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

import { getDocument } from 'pdfjs-dist/legacy/build/pdf';
import 'pdfjs-dist/legacy/web/pdf_viewer.css';
import 'pdfjs-dist/legacy/build/pdf.worker.entry'

import SignaturePad from 'signature_pad';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      indexVente: -1, // always set
      refCulture: '',
      refDestination: '',
      isSignature: false,
      isOTP: false,
      pdf: null,
      zoom: 1,
      isPdfLoaded: false,
      isShow: {
        signature: false,
        otp: false
      },
      signaturePad: null,
      otp: {
        value: '',
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    vente(){
      return this.strategie.done[this.indexVente];
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    clientContact() {
      return this.getClientContact(this.user);
    }
  },
  watch: {
    isPdfLoaded(value) {
      if(value && this.isSignature){
        this.$nextTick(function(){
          this.signaturePad = new SignaturePad(this.$refs.signaturePad, {
            backgroundColor: 'rgb(255, 255, 255)'
          });
          var ratio =  Math.max(window.devicePixelRatio || 1, 1);
          var canvas = this.$refs.signaturePad;
          canvas.height = canvas.offsetHeight * ratio;
          canvas.width = canvas.offsetWidth * ratio;
          canvas.getContext("2d").scale(ratio, ratio);
        });
      }
    },
    zoom() {
      this.displayPdf();
    }
  },
  methods: {
    async initPdf() {
      const urlParams = {
        user_date: this.user.date, // patch for cache issues
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.vente.id
      };
      const pdfUrl = this.$apiDomain + this.getPath('/negoce/contrat', urlParams);      
      try {
        let loadingTask = getDocument(pdfUrl);
        this.pdf = await loadingTask.promise;
        this.displayPdf();
      } catch(error) {
        this.handleError({ is_custom: true, message: 'Erreur lors de la récupération du contrat (code: ' + error.code + ')' });
      }
    },
    async displayPdf() {
      if(! this.pdf){
        return;
      }
      try {
        let page = await this.pdf.getPage(1);
        this.renderPage(page, 1);
      } catch(error) {
        this.handleError({ is_custom: true, message: "Erreur lors de l'affichage de la page 1 (code: " + error.code + ')' });
      }
    },
    async renderPage(page, pageIndex){
      
      var canvasId = 'pdf-canvas-' + pageIndex;
      var canvas = this.$el.querySelector('#' + canvasId);
      var isNewCanvas = false;
      if(! canvas){
        isNewCanvas = true;
        canvas = document.createElement('canvas');
        canvas.style.display = 'block';
        canvas.id = canvasId;
      }
      var context = canvas.getContext('2d');

      // Support HiDPI-screens.
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      var transform = ratio !== 1 ? [ratio, 0, 0, ratio, 0, 0] : null;

      var viewport = page.getViewport({ scale: 1 });
      var scale = (this.$el.offsetWidth - (this.zoom == 1 ? 22 : 2)) / viewport.width;
      viewport = page.getViewport({ scale: Math.min(scale*this.zoom, ratio) });

      canvas.width = Math.floor(viewport.width * ratio);
      canvas.height = Math.floor(viewport.height * ratio);
      canvas.style.width = Math.floor(viewport.width) + 'px';
      canvas.style.height =  Math.floor(viewport.height) + 'px';

      page.render({ canvasContext: context, viewport: viewport, transform: transform });

      if(isNewCanvas){
        this.$el.querySelector('#pdf-container').insertBefore(canvas, this.$el.querySelector('#pdf-container > section'));
      }

      pageIndex += 1;
      if(pageIndex <= this.pdf.numPages){
        try {
          let nextPage = await this.pdf.getPage(pageIndex);
          this.renderPage(nextPage, pageIndex);
        } catch(error) {
          this.handleError({
            is_custom: true,
            message: "Erreur lors de l'affichage de la page " + pageIndex + ' (code: ' + error.code + ')'
          });
        }
      } else {
        this.isPdfLoaded = true;
      }
    },
    onScroll(event) {
      if(! this.isPdfLoaded || this.isShow.signature){
        return;
      }
      var pdfContainer = event.target; // this.$el.querySelector('#pdf-container');
      if(Math.round(pdfContainer.scrollTop + pdfContainer.offsetHeight - pdfContainer.scrollHeight) >= 0){
        this.isShow.signature = true;
      }
    },
    downloadContrat() {
      const urlParams = {
        user_date: this.user.date, // patch for cache issues
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.vente.id,
        download: 1
      };
      const fileUrl = this.$apiDomain + this.getPath('/negoce/contrat', urlParams);
      if (typeof cordova !== 'undefined') {
        cordova.InAppBrowser.open(fileUrl, '_system');
      } else {
        window.open(fileUrl, '_blank');
      }
    },
    deleteSignature() {
      this.signaturePad.clear();
    },
    async saveSignature() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      if(this.signaturePad.isEmpty()){
        this.setErrorMsgList('signaturePad', 'Pour signer le contrat, vous devez dessiner votre signature avec votre '
          + (this.$ons.platform.isWebView() ? 'doigt' : 'souris') + ' en dessous du contrat PDF'
        );
        this.$scrollTop();
        return;
      }

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.vente.id,
        data: this.signaturePad.toDataURL()
      };

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/signe');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.pageStack.length > 1 && this.pageStack.pop();
        this.$showToast('Contrat signé électroniquement');
      } catch(error) {
        if(error && error.status == 409){
          this.isSignature = false;
        }
        this.handleError(error);
      }
    },
    async saveOTP() {
      if (this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      if(! this.otp.value){
        this.setErrorMsgList('inputOtp', '');
        this.isSubmit = false;
        return;
      }
      this.isShow.otp = false;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        index_vente: this.indexVente,
        id_vente: this.vente.id,
        otp: this.otp.value
      };

      const fetchInit = this.$getFetchInit();
      fetchInit.body = JSON.stringify(body);
      const callPath = this.$apiDomain + this.getPath('/negoce/signe');
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        this.pageStack.length > 1 && this.pageStack.pop();
        this.$showToast('Contrat signé électroniquement');
      } catch(error) {
        if(error && error.status == 409){
          this.isOTP = false;
        }
        this.handleError(error);
      }
    }
  }
};
</script>

<style>
.toolbar__center .toolbar-button--right {
  float: right;
  padding-top: 0;
  padding-bottom: 0;
}
#pdf-container > canvas {
  margin: 10px;
  border: 1px solid black;
}
.list-item--signature {
  padding: 0 10px;
}
.list-item--signature__center {
  margin: 0;
  padding: 9px 0;
  min-height: unset;
}
.list-item--signature__center canvas {
  box-sizing: border-box;
  width: 100%;
  border-style: solid;
  border-width: 2px;
  border-radius: 6px;
  max-width: 500px;
  background-color: white;
}
</style>